export const ORGS = {
	COUNTIES_MANUKAU: "Counties Manukau",
	WDHB: "WDHB",
	NORTHLAND: "Northland",
};
